import { CampaignStepActivateDataInitial } from 'modules/campaigns/campaign-steps/components/activate-campaign-step/types'
import { WEEKDAYS_KEYS_FOR_BACKEND, WeekdaysKeys } from './constants'
import { SelectedWeekDaysType, SelectedWeekDaysTypeForBackend } from './types'

export const chosenWeekdaysForBackend = (chosenWeekdays: SelectedWeekDaysType) => {
  const offsetChosenWeekDays = Object.entries(chosenWeekdays).reduce(
    (sum, [key, value]) => ({
      ...sum,
      [WEEKDAYS_KEYS_FOR_BACKEND[key as WeekdaysKeys]]: value,
    }),
    {} as SelectedWeekDaysTypeForBackend,
  )

  return Object.entries(offsetChosenWeekDays)
    .filter(([_, value]) => !value)
    .map(([key]) => Number(key))
}

export const chosenWeekdaysForFrontend = (
  excludedWeekdays: CampaignStepActivateDataInitial['excludedWeekdays'] | undefined,
) => {
  return Object.entries(WeekdaysKeys).reduce(
    (summary, [_, weekKey]) => ({
      ...summary,
      [weekKey]: !excludedWeekdays?.includes(Number(WEEKDAYS_KEYS_FOR_BACKEND[weekKey])),
    }),
    {},
  ) as SelectedWeekDaysType
}
